module.exports = __webpack_public_path__ + "media/images/kids16-3281b1710ef203889960d43e8cd243e0.jpg";